






















































































































































import { listFactory } from '@/main/pages';
import { dropdownListProvider } from '@/main/dropdownApi';
import { PageMode } from '@/main/utils/pageMode';
import InfoSideBar from '#components/dms/InfoSideBar/InfoSideBar.vue';
import { openEdit } from '@/main/router/routerPath';
import { Partner } from '../partner';
import { store } from './store/list';
import { showAlert } from '@/main/utils/notifications';
import { apiProvider } from '@/modules/kartoteka/vozidlo/api';
import { listMutations } from './store/types';
	import {
		NAME,
		VOZIDLO_CDB, DMS_AS_GOLDEN_ACCOUNT_ID_PREFIX, TENANT_NAME, DEFAULT_START_MONTH, VALID_VIN_LENGTH,
		DMS_CREATED_GOLDEN_ACCOUNT_ID_KVPS_ISSUE,
		CROSS_DEALER_KVPS_SEARCH_ISSUE,
		ACTUAL_CUSTOMER_DATA_INVALID_IN_CDB_DATA_ISSUE,
		NEW_CUSTOMER_CREATE_ISSUE,
		CUSTOMER_ABSENT_IN_PARTNER_TABLE,
		SUCCESS
} from './constants';

export default listFactory(NAME, store).extend({
	components: {
		PartnerSelect: Partner.components.Select,
		InfoSideBar,
	},
	mounted(){
        var element = document.getElementsByClassName("el-main");
		if(element.length!=0)
			element[0].classList.remove('d-flex');
    },
	computed: {
		mutationsMappers() {
			return {
				zakaznik: `${this.storeUri}/${listMutations.VOZIDLO_ZAKAZNIK_FILTER_SELECT_MAPPER}`,
				leasingZakaznik: `${this.storeUri}/${listMutations.VOZIDLO_LEASING_ZAKAZNIK_FILTER_SELECT_MAPPER}`,
				pojistovna: `${this.storeUri}/${listMutations.VOZIDLO_POJISTOVNA_FILTER_SELECT_MAPPER}`,
			};
		},
	},
	methods: {
		OnVyrobekvozOznChange() {
			if (!this.VyrobekvozOzn || this.VyrobekvozOzn === '') {
				this.dropdownList.Tablpozice = [];
				this.dropdownList.Typkod = [];
			} else {
				dropdownListProvider.GetTablPoz(this.VyrobekvozOzn!).then(({ data }) => {
					this.dropdownList.Tablpozice = data;
					this.dropdownList.Typkod = [];
				});
			}
		},
		OnTablpoziceChange(Tablpozice: string | number) {
			if (Tablpozice) {
				dropdownListProvider.GetTypKodMin4(this.VyrobekvozOzn!, this.Tablpozice!).then(({ data }) => {
					this.dropdownList.Typkod = data;
				});
			} else {
				this.dropdownList.Typkod = [];
				this.Typkod = null;
			}
		},
		async routeVozidloCDB() {
			if(!this.KaroserieNr || (this.KaroserieNr && this.KaroserieNr?.length != VALID_VIN_LENGTH)){
				showAlert({
					message: this.LocalizeChyboveHlasky('AlertMsgForVIN'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
			}
			else{
				this.startLoading();
				const { data: response } = await apiProvider.getVehicleCustomerDetailsByVIN(this.KaroserieNr);
				this.endLoading();
				if(!response){
					showAlert({
						message: this.LocalizeChyboveHlasky('AlertMsgForVINNotFound'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'info' },
					});
					return;
				}
				
				// if VIN belongs to logged in user Dealer.
				if(response.IsVINFoundInDealer != null && response.IsVINFoundInDealer){
					showAlert({
						message: this.LocalizeChyboveHlasky('AlertMsgForDealersOwnVIN'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'info' },
					});
					return;
				}
				if(response.ValidationErrorText == CUSTOMER_ABSENT_IN_PARTNER_TABLE)
				{
					showAlert({
						message: "DMS_TENANT_KVPS record in PARTNER table missing, create record in PARTNER table and try again.",
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'info' },
					});
					return;	
				}
				if( response.ValidationErrorText == DMS_CREATED_GOLDEN_ACCOUNT_ID_KVPS_ISSUE)
				{
					showAlert({
						message: "KVPS of this VIN is not configured in CDB_TENANT_KVPS in Common. Please connect DMS Support team.",
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'info' },
					});
					return;	
				}
				if(response.ValidationErrorText == CROSS_DEALER_KVPS_SEARCH_ISSUE && 
					response.ZakaznikIdText !=null && response.ZakaznikIdText.startsWith(DMS_AS_GOLDEN_ACCOUNT_ID_PREFIX)){
					const goldenAccountId = response.ZakaznikIdText.split('_');
					const loggedInUserTenantCode = window.localStorage.getItem(TENANT_NAME) || '';
					const dealerKvpsCodes = response.DealerKvps;
					//KVPS as customer SAMPLE DmsGoldenAccountID = DMS_90000_21030
					if(goldenAccountId && (goldenAccountId.length >= 3) && (goldenAccountId[0] === DMS_AS_GOLDEN_ACCOUNT_ID_PREFIX)){
						if((loggedInUserTenantCode !== goldenAccountId[1]) || (dealerKvpsCodes.includes(goldenAccountId[2]) === false)){
							showAlert({
								message: this.LocalizeChyboveHlasky('AlertMsgForActualGoldenAccountId').replace(/#VIN#|#DMSCREATEDGOLDENACCOUNTID#/g, (m : string) => {
									if(m === '#VIN#')
										return response.KaroserieNr;
									else if(m === '#DMSCREATEDGOLDENACCOUNTID#') 
										return response.ZakaznikIdText;
									return "";
								}),
								title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
								options: { type: 'info' },
							});
							return;
						}
					}
				}
				if( response.ValidationErrorText !=null && response.ValidationErrorText == ACTUAL_CUSTOMER_DATA_INVALID_IN_CDB_DATA_ISSUE 
					&& !response.IsValidCustomerData && response.InvalidCustomerFieldList != null ){
					 showAlert({
					 	message: this.LocalizeChyboveHlasky
					 	('AlertMsgForFalseCustomer').replace(/#VIN#|#INVALIDCUSTOMERFIELDLIST#/g, (m : string) => {
					 		if(m === '#VIN#')
					 			return response.KaroserieNr ;
					 		else if(m === '#INVALIDCUSTOMERFIELDLIST#' )
					 			return response.InvalidCustomerFieldList.replaceAll('_',', ') ;
					 		return "";
					 	}),
					 	title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					 	options: { type: 'info' },
					 });
					 return;
				}
				if(response.ValidationErrorText == NEW_CUSTOMER_CREATE_ISSUE)
				{
					showAlert({
						message: "Issue occurred during new customer creation for this VIN hence VIN and Customer both are not created. Please connect DMS Support team.",
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'info' },
					});
					return;	
				}
				if (response.ValidationErrorText == SUCCESS && 
						response.KaroserieNr != null && response.VyrobekvozOzn!=null 
						&& response.Typkod!=null && response.TablPozice!=null && response.ZakaznikId!=null )
				{
					await openEdit(NAME,PageMode.CREATE,
					{
						props:true,
						karoserieNr: response.KaroserieNr,
						spz: response.Spz,
						vyrobekvozOzn: response.VyrobekvozOzn,
						typkod: response.Typkod,
						typkodText: response.TypkodText,
						modelRok: (response.ModelRok).toString(),
						tablPozice: response.TablPozice,
						barvaKod: response.BarvaKod,
						barvaText: response.BarvaText,
						prodejDat: new Date(response.ProdejDat),
						garPzn: response.GarPzn,
						tpNr: (response.KaroserieNr).substring(0,11),
						vyrobaRok: new Date(response.VyrobaRok,DEFAULT_START_MONTH),
						motorNr: (response.MotorNr) ? (response.MotorNr).replaceAll(',','').substring(0,15) : (response.KaroserieNr).substring(0,15),
						palivoPzn: response.PalivoPzn,
						ovkategPzn: response.OvkategPzn,
						ovdruhPzn: response.OvdruhPzn,
						zakaznikId: response.ZakaznikId,
						zakaznikIdText: response.ZakaznikIdText,
						objem: response.Objem,
						vykon: response.Vykon,
						vozidloId: -1,//To save the vehicles
						contactDetails: response.ContactDetails
					});
				}
				else
				{
					showAlert({
						message: "Search In CDB VIN creation failed. Please connect DMS Support team.",
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'info' },
					});
					return;	
				}
			}
		}
	}
});
